.notificationGlobal {
	margin-right: 10px !important;
	margin-left: 10px !important;
	margin-top: 1em;
	height: 100%;

	.removeNotification {
		margin-bottom: 1em;

		div {
			display: flex;
			float: right;
			background: #d7373f;
			padding: 7px;
			padding-left: 1em;
			padding-right: 1em;
			color: white;
			border-radius: 10px;
			font-size: 15px;
			cursor: pointer;
		}
	}

	.notificationScroll {
		margin-left: 0px;
		margin-right: 0px;
		width: 100%;
		padding-left: 1em;
		padding-right: 1em;

		@media (max-width: 400px) {
			padding-left: 5px;
			padding-right: 5px;
		}

		&::-webkit-scrollbar {
			width: 5px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #a8a8a8;
			border-radius: 15px;
		}

		.notification {
			padding-top: 1em;
			padding-bottom: 1em;
			display: flex;
			justify-content: center;
			flex-direction: column;

			width: 100%;
			box-shadow: 5px 5px 10px #dfe1e6;
			background-color: white;
			border-radius: 10px;

			min-height: 5em;
			margin-bottom: 1em;

			@media (max-width: 400px) {
				box-shadow: inherit;
				background-color: #f3f3f3;
				border-radius: 5px;
			}

			.baseNotification {
				align-items: center;

				.icon {
					cursor: pointer;
				}

				.notificationDate {
					@media (max-width: 400px) {
						font-size: 12px;
						font-weight: 600;
						padding-right: 5px;
						padding-left: 5px;
					}
				}

				.notificationIcon {
					@media (max-width: 400px) {
						font-size: 13px;
						display: none;
					}
				}

				.notificationText {
					@media (max-width: 400px) {
						padding-right: 5px;
						padding-left: 5px;
					}
				}
			}
		}
	}
}
